const tours = {
  tour: "Tour",
  tours: "Tours",
  addOn: "Add On",
  addOns: "Add Ons",
  availableEscapes: "Available Escapes",
  availableExperiences: "Available Experiences",
  getRequest: "Get Request",
  sendRequest: "Send Request",
};

export default tours;
